import { render, staticRenderFns } from "./ReferralProgramusd.vue?vue&type=template&id=f230b276&"
import script from "./ReferralProgramusd.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramusd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports